<template>
  <div id="app">
    <keep-alive>
        <router-view v-if="isRouterAlive"/>
    </keep-alive>
  
    <!-- <h2>{{$store.state.global.age}}</h2> -->
  </div>
</template>

<script>
export default {
  name: "app",
  provide() {
    return {
      reload: this.reload,
    };
  },

  data() {
    return {
      isRouterAlive: true,
    };
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => (this.isRouterAlive = true));
    },
    isIE() {
      if (!!window.ActiveXObject || "ActiveXObject" in window) {
        this.$message.error(this, "当前浏览器版本过低，请更换或者升级浏览器");
      } else {
        return false;
      }
    },
    autoChange() {
      var locale = localStorage.getItem("locale");
      // console.log("用户设置的语言" + locale);
      // console.log("当前系统语言" + navigator.language);
      // console.log("当前系统语言" + navigator.languages);
      if (locale === undefined || locale == null) {
        switch (navigator.language) {
          case "en":
          case "en-US":
            console.log("当前系统是英文语言");
            this.$i18n.locale = "en";
            break;
          case "zh":
          case "zh-CN":
          case "zh-cn":
          case "zh-tw":
          case "zh-hk":
          case "zh-sg":
          case "zh-mo":
            this.$i18n.locale = "zh";
            break;
          default:
            this.$i18n.locale = "zh";
        }
      } else {
        // console.log("已经设置了语言" + locale);
        // console.log(this.$i18n)
      }
    },
  },
  mounted() {
    this.isIE();
    this.autoChange();
  },
};
</script>

<style lang="scss">
@import "./assets/normalize.css";
@import "./sass/element-cover.scss";
@import "./assets/css/mobile.css";
body,
html,
p,
div,
li,
header,
footer,
section,
nav,
a,
span,
h1,
h2,
h3,
h4,
h5,
h6 {
  word-break: break-word;
}
.chat-box-v {
  cursor: pointer;
  margin: 0;
  // padding: 10px;
  position: fixed;
  right: -0px;
  bottom: 20px;
  z-index: 70;
  margin-top: -90px;
  // background: #4694d6;
  // font-size: 14px;
  text-align: center;
  color: #fff;
  // width: 80px;
  // height: 60px;
  img {
      width: 80px;
  height: 60px;
  }
  // p {
  //   margin-top: 5px;
  // }
}

/* 小屏幕的样式*/
@media screen and (max-width: 720px) {
  html,
  body,
  #app {
    width: 100%;
    height: 100%;
  }
  .chat-box-v {
    padding: 10px 5px;
    font-size: 12px;
    img {
      width: 50%;
    }
    p {
      margin-top: 5px;
    }
  }
}

/* 大屏幕的样式*/
@media screen and (min-width: 721px) {
  html,
  body,
  #app {
    width: 100%;
    min-width: 1200px;
  }
}

#fp-nav {
  display: none !important;
}
/* 定义滚动条样式 */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background-color: rgba(240, 240, 240, 1);
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  border-radius: 5px;
  background-color: rgba(240, 240, 240, 0.5);
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background-color: #ccc;
}

.container .main .content {
  overflow-x: hidden !important;
}
#app /deep/ .el-table .cell {
  padding: 0 0px 0 5px !important;
}
/* //全局设置table的最大高度 */
div,
p,
span,
li {
  word-break: break-word;
}
#app /deep/ .container .el-header,
#app /deep/ .container .header {
  border-radius: 0;
}
#app /deep/ .el-table .el-table__body-wrapper {
  // max-height:500px;
  max-height: 70vh;
  overflow: auto;
  width: calc(100% + 15px);
  &:before {
    height: 0;
  }
}
.over {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.el-range-separator {
  width: 60px !important;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
ul,
ol,
li {
  list-style-type: none;
}
// common
#app {
  // 圆角
  /deep/ .button-radius-5px {
    border-radius: 5px;
  }
  // 蓝色
  /deep/ .text-color-blue {
    color: $--color-text-blue;
  }
  /deep/ .bg-color-blue {
    background-color: $--color-text-blue;
  }
  /deep/ .border-color-blue {
    border-color: $--color-text-blue;
  }
  // 红色
  /deep/ .text-color-red {
    color: $--color-text-red;
  }

  //以下样式-客户管理弹窗样式 from shao yh
  .reset-dialog /deep/ {
    #hr {
      position: relative;
      &::after {
        content: "";
        display: block;
        width: 1px;
        height: 80px;
        position: absolute;
        top: 0;
        right: 50%;
        background-color: #fff;
      }
    }
    .box-sizing {
      box-sizing: border-box;
    }
    .p20 {
      padding: 20px 20px 0;
    }
    .crate-time-label {
      display: inline-block;
      width: 80px;
      text-align: center;
    }
    .el-dialog {
      .table-box {
        border: 1px solid #ebeef5;
        border-bottom: none;
        box-sizing: border-box;
        width: 100%;
        .wtf-list {
          position: absolute;
          top: 0;
          right: -120px;
          display: none;
          background-color: #fff;
          border-radius: 4px;
          padding: 10px 10px;
          width: 120px;
          box-shadow: 0 0 8px rgba(0, 0, 0, 0.3);
          z-index: 100;
          font-size: 14px;
          li {
            cursor: pointer;
            &:hover {
              color: #50b6e8;
            }
          }
        }
        .text-center {
          text-align: center;
        }
        .talk-methods {
          cursor: pointer;
        }
        .has-border-color1 {
          border: 1px solid #333;
          padding: 2px 2px;
          font-size: 12px;
        }
        .table {
          width: 100%;
          .cell {
            overflow: visible;
          }
          .flag {
            display: block;
            width: 80px;
            max-height: 80px;
            margin: 0 auto;
          }
          .wtf-box {
            position: relative;
          }
          .details,
          .talk {
            text-align: center;
            color: $--color-text-blue;
            cursor: pointer;
            line-height: 2;
            color: $--color-text-blue;
          }
          .country {
            text-align: center;
            font-size: 14px;
            color: $--color-text-blue;
          }
          .product-name,
          .phone,
          .talk-methods {
            color: $--color-text-blue;
          }
          .color-orange {
            color: $--color-primary;
          }
        }
        .check-box {
          display: flex;
          align-items: center;
          justify-content: center;
          .leftbar,
          .rightbar {
            flex: 1;
          }
          .rightbar {
            p {
              color: $--color-primary;
            }
          }
        }
      }
      position: relative;
      .header-btn-group {
        position: absolute;
        right: 20px;
        top: 8px;
        z-index: 100;
        display: inline-block;
        width: 150px;
        text-align: right;
        li {
          display: inline-block;
          margin-left: 12px;
          font-size: 18px;
          color: #fff;
          cursor: pointer;
          user-select: none;
          padding: 4px;
        }
      }
      .el-dialog__body {
        padding: 0;
      }
      .current-userinfo {
        display: flex;
        justify-content: space-between;
        width: 100%;
        padding: 10px 20px 15px;
        box-sizing: border-box;
        border-bottom: 1px solid #e5e5e5;
        & > div {
          line-height: 28px;
          flex: 1;
          &.text-right {
            text-align: right;
          }
        }
      }
      .data-bar {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 15px 20px;
        box-sizing: border-box;
        li {
          flex: 1 0 27%;
          height: 115px;
          margin-right: 15px;
          color: #fff;
          padding: 20px;
          box-sizing: border-box;
          &:nth-of-type(3),
          &:nth-of-type(4) {
            flex: 0 0 16%;
          }
          &:nth-of-type(1) {
            background-color: #7ecdf4;
          }
          &:nth-of-type(2) {
            background-color: #fbc57d;
          }
          &:nth-of-type(3) {
            background-color: #f4947e;
          }
          &:nth-of-type(4) {
            background-color: #f3f07d;
            margin-right: 0;
          }
          h5 {
            font-size: 18px;
            font-weight: 500;
          }
          .badge-btn {
            display: inline-block;
            padding: 5px 10px;
            border-radius: 6px;
            border: 1px solid #fff;
            color: #fff;
            text-align: center;
            font-size: 14px;
            margin-top: 25px;
            cursor: pointer;
            &:hover {
              background-color: rgba(250, 114, 2, 0.5);
              border-color: transparent;
            }
          }
          .mt20 {
            margin-top: 20px;
          }
          .fz16 {
            font-size: 16px;
          }
        }
      }
      .tab-content {
        padding: 0 20px 20px;
        box-sizing: border-box;
        .tab-content-box {
          border: 1px solid #e5e5e5;
          box-sizing: border-box;
        }
        .tab-list {
          background-color: #f2f2f2;
          border-bottom: 1px solid #e5e5e5;
          li {
            display: inline-block;
            vertical-align: middle;
            height: 60px;
            line-height: 60px;
            font-size: 15px;
            padding: 0 20px;
            cursor: pointer;
            &.active {
              background-color: rgb(250, 114, 2);
              color: #fff;
              transition: all 0.3s;
            }
          }
        }
        .tab-content-list {
          .tab-list-item-div {
            line-height: 40px;
            height: 40px;
            padding-left: 20px;
            box-sizing: border-box;
            &:nth-of-type(2n) {
              background-color: rgb(242, 242, 242);
            }
            &:nth-of-type(2n + 1) {
              background-color: rgb(255, 255, 255);
            }
            .item-div-value {
              padding-left: 15px;
              box-sizing: border-box;
            }
          }
        }
        #tab-content-list-item-2 {
          .img-box {
            flex: 0 0 100px;
            box-sizing: border-box;
            padding-top: 20px;
            img {
              display: block;
              margin: 0 auto;
              width: 80px;
              height: 80px;
            }
          }
          .text-box {
            flex: 1;
            box-sizing: border-box;
            padding-top: 20px;
            padding-left: 20px;
            .flex {
              margin-bottom: 20px;
            }
          }
        }
        #tab-content-list-item-6,
        #tab-content-list-item-5,
        #tab-content-list-item-4 {
          margin-top: 10px;
        }
      }
    }
  }
  .min-kfgl-bar {
    position: fixed;
    bottom: 0;
    right: 0;
    z-index: 99;
    background-color: #fa7202;
    color: #fff;
    font-size: 16px;
    height: 40px;
    line-height: 40px;
    width: 120px;
    cursor: pointer;
  }
  .kfglbar-enter,
  .kfglbar-leave-to {
    bottom: -50px;
  }
  .kfglbar-enter-to,
  .kfglbar-leave {
    bottom: 0;
  }
  .kfglbar-enter-active,
  .kfglbar-leave-active {
    transition: all 0.5s;
  }
}
.el-message-box {
  width: 340px;
}
</style>
